import React, { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import { ToastTooltip } from 'components/ToastTooltip';
import CopyChecked from 'images/copy_checked.svg';
import { CopyIcon16 } from 'modules/icons/CopyIcon16';

interface ICopyAddressProps {
  address: string;
  whiteIcon?: boolean;
}

const useStyles = makeStyles<Theme>((theme) => ({
  copyAddressRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    overflow: 'hidden',
    '&:hover': {
      cursor: 'pointer',
    },
    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      '& > img': {
        margin: '0 ',
      },
    },
    '& svg': {
      color: '#ABABAB',
      width: 16,
      height: 16,
      '&:hover': {
        color: '#eeeeee',
      },
    },
  },
  copyAddressRootWhite: {
    '& svg': {
      color: '#fff',
      '&:hover': {
        color: '#eeeeee',
      },
    },
  },
  input: {
    alignItems: 'center',
    marginBottom: '32px',
    fontSize: '18px',
    fontWeight: 400,
    maxWidth: '282px',
    textAlign: 'center',
    wordBreak: 'break-all',
  },
  button: {
    width: 80,
    borderRadius: 0,
  },
}));

export const CopyAddress = ({ address, whiteIcon }: ICopyAddressProps) => {
  const classes = useStyles();

  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);
  const onCopyClicked = () => {
    navigator.clipboard.writeText(address);
    if (copyTooltipOpen) {
      return;
    }
    setCopyTooltipOpen(true);
    setTimeout(() => {
      setCopyTooltipOpen(false);
    }, 3 * 1000);
  };

  return (
    <div className={classNames(classes.copyAddressRoot, whiteIcon && classes.copyAddressRootWhite)}>
      <ToastTooltip
        style={{ width: '100%', paddingRight: '25px' }}
        open={copyTooltipOpen}
        message="Copied"
        icon={CopyChecked}
        placement="top"
      >
        <CopyIcon16
          onClick={(e) => {
            e.stopPropagation();
            onCopyClicked();
          }}
        />
      </ToastTooltip>
    </div>
  );
};
